import React from 'react';
import { Card } from 'react-bootstrap';

const CardCustom = (props) => {
	return (
		<Card className={props.className}>
			{props.children}
		</Card>
	);
};

export default CardCustom;	